<template>
    <div v-if="Alerts && Alerts.length">
        <div 
            v-for="alert in Alerts" 
            :key="alert.id" 
            :id="generateAlertId(alert)" 
            class="header-alert" 
            :class="alert.AlertType ? alert.AlertType.AlertCssClass : ''">
            <h3 class="fulton-alert">
                {{ alert.AlertTitle }}
            </h3>
            <div class="details">
                <p>
                    {{ alert.AlertDescription }}
                </p>
            </div>
            <div class="shut">
                <button type="button" class="close-alert">
                    &times;<span class="sr-only">Close announcement for {{ alert.AlertTitle }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Alerts',
    props: ['Alerts'],
    methods: {
        generateAlertId(alert) {
            // Convert AlertTitle to clean Pascal case ID with unique GUID suffix
            let titlePart = (alert.AlertTitle || '').replace(/[^\w]/g, '');
            if (titlePart) {
                titlePart = titlePart.charAt(0).toUpperCase() + titlePart.slice(1);
            }
            
            // Use alert id and take first 8 characters, removing dashes and curly brackets
            const idSuffix = (alert.id || '').replace(/-/g, '').replace(/{/g, '').replace(/}/g, '').substring(0, 8);
            return `${titlePart}_${idSuffix}`;
        }
    }
}
</script>